import CheckboxTreeFilter from "./CheckboxTreeFilter";

class ProductServiceFilter extends CheckboxTreeFilter {
  chipLabelTransform = (x: string, data: any) => {
    const res: any = [];
    data.forEach((item: any) => {
      res.push(
        item.children
          .filter((child: { label: string; value: string }) => x === child.value)
          .map((i: any) => {
            return `${item.label} - ${i.label}`;
          })
      );
    });
    return res.join("");
  };
}

export default ProductServiceFilter;
